// extracted by mini-css-extract-plugin
module.exports = {"order_lists":"OrderListScreen_order_lists__3INe-","table":"OrderListScreen_table__1MbRY"};